<template>
    <vx-selectable
        :modelValue="model ?? undefined"
        placeholder="Voxie opt-in timestamp"
        :taggable="true"
        :loading="loading"
        :options="options ?? []"
        :error="props.error"
        data-test="attribute-key-selectable"
        @search="search"
        @update:modelValue="onChange"
    ></vx-selectable>
</template>

<script lang="ts" setup>
import { VxSelectable } from '@voxie/frontend-components';
import { onUnmounted, watch } from 'vue';
import { useSearchRequest } from '~/composables/useSearchRequest';
import { useToasted } from '~/composables/useToasted';
import { adminRndClient } from '~/services';

const props = defineProps<{ teamId: number; error?: string }>();

const model = defineModel<string | null>({ required: true });

const toasted = useToasted();

const {
    loading,
    response: options,
    error: searchError,
    createSearch,
    cancelSearch,
    cancelKey,
} = useSearchRequest<string[]>(adminRndClient, 'kiosk-rnd-attribute-keys');

const onChange = (key?: string | null) => {
    model.value = key ? key.toLowerCase() : null;
};

const search = createSearch(async (query?: string) => {
    const { data } = await adminRndClient.getAttributeKeys(props.teamId, { query }, { cancelKey });

    return data.data;
});

watch(searchError, (message) => {
    if (message !== undefined) {
        toasted.error(message);
    }
});

search();

onUnmounted(() => {
    cancelSearch();
});
</script>
